// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3SvxP","label":"LabeledBox_label__2lImr"};